import styled from 'styled-components';

import Card from 'antd/es/card';

const StyledCard = styled(Card)`
  background-color: #FFFFFF;
  border: none;
  border-radius: 8px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);

  & .ant-card-body {
    display: flex;
    flex-direction: column;
  }
`;

export default StyledCard;
